export function getdata() {
	var obj = {
		headData: [{
				title: "姓名",
				prop: "nickName",
				width: "80",
				custom: true,
			},
			{
				title: "用户名",
				custom: true,
				prop: "username",
				width: "80"
			},
			{
				title: "手机号",
				custom: true,
				prop: "phoneNumber",
				width: "100"
			},
			{
				custom: true,
				title: "邮箱",
				prop: "email",
				width: 160,
			},

		],
		tableData: [{}],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

		Roleformlist: [{
				prop: "roleName",
				label: "角色名",
				type: "input",
				isnotnull: true
			},
			{
				prop: "parentId",
				label: "角色组",
				type: "select",
				isnotnull: true
			},
			{
				prop: "remark",
				label: "描述",
				type: "textarea",
			},
		],
		Roleformdata: {
			roleName: "",
			parentId: "",
			remark: ""
		},
		headDatanochoose: [{
				title: "姓名",
				prop: "username",
			},
			{
				title: "用户名",
				prop: "nickName",
			},
			{
				title: "手机号",
				prop: "phoneNumber",
			},
		],
		headDatachoose: [{
				title: "姓名",
				prop: "username",
			},
			{
				title: "用户名",
				prop: "nickName",
			},
			{
				title: "手机号",
				prop: "phoneNumber",
			},
		],
		copyRoleformlist: [{
			prop: "roleName",
			label: "角色名",
			type: "input",
			isnotnull: true
		},
		],
		copyRoleformdata: {
			roleName: "",
		},
		taskData: [{
				title: "批次",
				prop: "batchNo",
				width: "190",
			},
			{
				title: "状态",
				prop: "status",
				width: "70",
				custom: true,
			},
			{
				title: "文件名称",
				prop: "fileName",
				width: "350"
			},
			{
				custom: true,
				title: "创建时间",
				prop: "createTime",
				width: 130,
			},
			{
				custom: true,
				title: "完成时间",
				prop: "completeTime",
				width: 130,
			},
			{
				title: "操作",
				prop: "cz",
				width: "100",
				fixed:"right",
				custom:true
			}

		],
	}
	return obj
}
